<template>
    <div class="conditional-field">
        <Field
            type="radio"
            v-model="localValue"
            :label="label"
            :params="{
                options: options,
                name: name || label,
                tooltipContent: tooltipContent,
            }"
            :required="required"
            :disabled="disabled"
        />
        <div v-if="shouldShowContent" class="conditional-field-content">
            <template v-for="option in options" :key="option.value">
                <slot
                    v-if="shouldShowSlot(option.value)"
                    :name="option.value"
                />
            </template>
        </div>
    </div>
</template>

<script>
import Field from '@/components/Field.vue';
export default {
    name: 'ConditionalField',
    components: {
        Field,
    },
    props: {
        modelValue: {
            type: [Boolean, String, Number, null],
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
            default: () => [
                {
                    label: 'Yes',
                    value: true,
                },
                {
                    label: 'No',
                    value: false,
                },
            ],
        },
        name: {
            type: String,
            default: '',
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        customBGColor: {
            type: String,
            default: 'var(--neutral-400)',
        },
        tooltipContent: {
            type: String,
            default: '',
        },
    },
    emits: ['update:modelValue', 'change'],
    computed: {
        localValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('change', value);
            },
        },
        shouldShowContent() {
            return this.options.some((option) =>
                this.shouldShowSlot(option.value)
            );
        },
    },
    methods: {
        shouldShowSlot(optionValue) {
            // Only show slot if:
            // 1. The parent provides a slot with this name (e.g., #true, #false)
            // 2. The current localValue matches this option's value
            return this.$slots[optionValue] && this.localValue === optionValue;
        },
    },
};
</script>

<style scoped>
.conditional-field {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
}

.conditional-field-content {
    background-color: v-bind(customBGColor);
    padding: var(--space-3);
    border-radius: var(--radius-sm);
    gap: 0.625rem;
}
</style>
